import { createReducer } from 'utils/redux';
import { Map } from 'immutable';
import { actionTypes } from 'modules/Profile/redux/bankAccounts/actions';

const initialState = Map({
  loading: false,
  error: '',
  data: null,
  isDataPresented: null,
});

const onStartFetchBankAccounts = (state) => state.set('loading', true);

const onSuccessFetchBankAccounts = (state, { payload }) =>
  state.set('loading', false).set('data', payload).set('error', '');

const onErrorFetchBankAccounts = (state, { payload }) =>
  state.set('loading', false).set('error', payload);

const onSetDataPresented = (state, { payload }) => state.set('isDataPresented', payload);

const onReset = () => initialState;

export default createReducer(initialState, {
  [actionTypes.BANK_ACCOUNTS_REQUEST_START]: onStartFetchBankAccounts,
  [actionTypes.BANK_ACCOUNTS_REQUEST_SUCCESS]: onSuccessFetchBankAccounts,
  [actionTypes.BANK_ACCOUNTS_REQUEST_FAILURE]: onErrorFetchBankAccounts,
  [actionTypes.BANK_ACCOUNTS_SET_DATA_PRESENTED]: onSetDataPresented,
  [actionTypes.BANK_ACCOUNTS_RESET]: onReset,
});
